var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hint)?_c('div',{staticClass:"hint"},[_c('p',[_vm._v(_vm._s(_vm.hint.text)+" "),(_vm.hint.examples)?_c('span',[_vm._v("Na przykład:")]):_vm._e()]),_c('ul',_vm._l((_vm.hint.examples),function(example){return _c('li',[_vm._v(_vm._s(example))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }